import { ConvexProvider } from "convex/react";
import { convex } from "./convexClient";

export default function ConvexClientProvider({ children }) {
  return <ConvexProvider client={convex}>{children}</ConvexProvider>;
}
